// extracted by mini-css-extract-plugin
export var active = "_1y-d";
export var blink = "_1y-e";
export var container = "_1y-5";
export var controls = "_1y-0";
export var controlsRight = "_1y-1";
export var fakeCursor = "_1y-c";
export var hidden = "_1y-b";
export var quillContainerSmall = "_1y-7";
export var quillEditor = "_1y-6";
export var quillEditorSmall = "_1y-8";
export var quillFormatButtons = "_1y-a";
export var quillToolbar = "_1y-9";
export var removePadding = "_1y-2";
export var state = "_1y-3";
export var stateTitle = "_1y-4";